module.exports = __webpack_public_path__ + "static/media/logo.8331e374.png";